import { render, staticRenderFns } from "./smartsoft.vue?vue&type=template&id=051bed5b&scoped=true"
import script from "./smartsoft.vue?vue&type=script&lang=js"
export * from "./smartsoft.vue?vue&type=script&lang=js"
import style0 from "./smartsoft.vue?vue&type=style&index=0&id=051bed5b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051bed5b",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/smartsoft.vue
// module id = E5vu
// module chunks = 0